import React from 'react';
import { Field } from 'formik';
import { InputNumber, InputNumberProps } from 'primereact/inputnumber';
import classNames from 'classnames';
import FormikFormGroup from '../FormikFormGroup';

export interface FormikInputNumberProps {
	[key: string]: any;
	className?: string;
	name: string;
	label?: string;
	required?: boolean;
	row?: boolean;
	caption?: string;
}

const FormikInputNumber = (props: FormikInputNumberProps & InputNumberProps) => {
	const { className ,id, name, label, required, row, caption, ...inputProps } = props;

	const renderInput = ({ field, form, meta }) => {
		return (
			<FormikFormGroup
				className={className}
				id={id}
				name={name}
				label={label}
				field={field}
				form={form}
				meta={meta}
				row={row}
				required={required}
				caption={caption}
			>
				<InputNumber
					id={id}
					{...field}
					{...inputProps}
					className={classNames('p-inputtext-sm w-100', {
						'p-invalid': Boolean(meta.touched && meta.error),
					})}
				/>
			</FormikFormGroup>
		);
	};

	return <Field name={name}>{renderInput}</Field>;
};

export default FormikInputNumber;
